import { render, staticRenderFns } from "./SupplierFax.vue?vue&type=template&id=850e76ec"
import script from "./SupplierFax.vue?vue&type=script&lang=js"
export * from "./SupplierFax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports